import {
  ACCOUNT_NAV_ITEM,
  SIMULATOR_NAV_ITEM,
  STATS_NAV_ITEM,
  TRAINER_NAV_ITEM,
} from '../constants/navigation';

const DEFAULT_RETURN_PATH = TRAINER_NAV_ITEM.to;

const ALLOWED_PATHS = new Set([
  TRAINER_NAV_ITEM.to,
  SIMULATOR_NAV_ITEM.to,
  STATS_NAV_ITEM.to,
  ACCOUNT_NAV_ITEM.to,
]);

export function getSafeReturnPath(from) {
  if (!from || typeof from !== 'string') {
    return DEFAULT_RETURN_PATH;
  }

  let decoded = from;
  try {
    decoded = decodeURIComponent(from);
  } catch {
    return DEFAULT_RETURN_PATH;
  }

  if (!decoded.startsWith('/') || decoded.startsWith('//') || decoded.includes('\\')) {
    return DEFAULT_RETURN_PATH;
  }

  const pathname = decoded.split('?')[0];
  if (!ALLOWED_PATHS.has(pathname)) {
    return DEFAULT_RETURN_PATH;
  }

  return decoded;
}

export function buildLoginPath(fromPathname, fromSearch = '') {
  const from = `${fromPathname}${fromSearch || ''}`;
  const params = new URLSearchParams();
  params.set('from', from);
  return `/login?${params.toString()}`;
}
